var head = document.getElementsByTagName('HEAD').item(0);
var style = document.createElement('link');
style.rel = 'stylesheet';
style.type = 'text/css';
style.href = 'https://s.trackingmore.com/plugins/v1/plugins.css?time=20221208';
head.appendChild(style);
if(typeof jQuery == 'undefined' || typeof $ == 'undefined'){
	var script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = 'https://s.trackingmore.com/bootstrap/jquery-2.1.1.min.js?time=20180928';
	head.appendChild(script);
}

var LC = {
	enNumbersRequired:"Enter your tracking number.",
	ptNumbersRequired:"Digite seu número de rastreamento.",
}


// Função auxiliar para somar dias a uma data
function addDaysToDate(dateString, days) {
    var parts = dateString.split("/");
    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var year = parseInt(parts[2], 10);
    if (year < 100) {
        year += 2000; // Adicionar o século para anos de dois dígitos
    }

    var date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + days);

    var newDay = date.getDate();
    var newMonth = date.getMonth() + 1;
    var newYear = date.getFullYear();

    var newDateString = padZero(newDay) + "/" + padZero(newMonth) + "/" + newYear;
    return newDateString;
}

// Função auxiliar para adicionar zero à esquerda de um número
function padZero(number) {
    return number.toString().padStart(2, "0");
}

function doTrack() {
    var pageContent = document.querySelector('.page__content.rte');
  if (pageContent) {
    window.scrollTo({
      top: pageContent.offsetTop,
      behavior: 'smooth'
    });
  }
	var num,expCode,lang,from;
	number=document.getElementById("button_tracking_number");
	expCode=document.getElementById("button_express_code").value;
	from = $("#button_tracking_number").closest("form");
	lang = from.find("input[name='lang']").val();
	num = number.value;
	if(!lang) lang = 'pt';
	num = num.replace(/\s+/g,"");

    var rastreamento = null;
    var data = null;
	
	if (num === "" || !/^[A-Za-z0-9-]{4,}$/.test(num)) {
		alert(eval("LC."+lang+"NumbersRequired")?eval("LC."+lang+"NumbersRequired"):"Enter your tracking number.");
		return false;
	}
if (expCode === "" && conteudo.indexOf(num) !== -1) {
        var linhas = conteudo.split("\n");
        for (var i = 0; i < linhas.length; i++) {
            var linha = linhas[i];
            var partes = linha.split(",");
            if (partes[0] === num) {
                rastreamento = partes[0];
                data = partes[1];
                break;
            }
        }
    }

    if (rastreamento && data) {
        var dataPrevisao = addDaysToDate(data, 14);

        var htmlModificado = `    
            <div class="rastreioninja">
                <div class="row align-items-center">
                    <div class="col-12 col-md-7 col-lg-6 order-md-1 col-centered aos-init aos-animate" data-aos="fade-up">
    
                        <h3 class="display-5 text-center">
    
                            <span class="badge badge-lg badge-rounded-circle badge-primary">
                                ${rastreamento} <i class="fas fa-check"></i>
                            </span>
    
                        </h3>
    
                        <h3 class="display-5 text-center">
    
                            <div class="alert alert-info fade show" role="alert" style="padding: 18px;font-size: 17px;background-color: #21252f;border-color: #21252e;text-align: center;">
                                <span>Previsão de Entrega: ${dataPrevisao}</span>
                            </div>
    
                        </h3>
    
                        <div class="rastreioninja">
                            <div class="item">
                                <div id="timeline">
                                    <div>
                                        <i class="fas fa-home" style="position: absolute;left: 52px;z-index: 9999999999;top: -41px;color: #3966ea;"></i>
                                    </div>
                                    <br>
                                    <div>
    
                                        <section class="time-line-data">
                                            <h3 class="year">${data}</h3>
                                            <section>
                                                <ul>
                                                    <li>Objeto postado</li>
                                                    <li style=" color: #352d2d91; font-size: 14px; ">
    
                                                    </li>
                                                    <li style="color: #3966ea; font-size: 10px;margin-top: 0vh;">
    
                                                    </li>
                                                    <li style="color: #352d2d91;font-size: 14px;margin-top: 0vh;">
                                                        06:13
                                                    </li>
                                                </ul>
                                            </section>
    
                                        </section>
                                    </div>
                                </div>
                            </div>
                            <div class="card card-border border-primary"></div>
                        </div>
                    </div> <!-- / .row -->
                </div> <!-- / .rastreioninja -->
            </div>
        `;
    
        var resultadoDiv = document.getElementById("resultado-rastreamento");
        resultadoDiv.innerHTML = htmlModificado;
    } else {
        if (expCode === "") {
            window.open('_blank').location = 'https://www.ordertracker.com/' + lang + '/track/' + num;
        } else {
            window.open('_blank').location = 'https://www.trackingmore.com/track/' + lang + '/' + num + '?express=' + expCode;
        }
    }

    return false;
}